import { useRef, useState } from "react";
import { useMediaQuery } from "../../../../hooks/useMediaQuery";
import { useAboutMeStyles } from "./styles";

import handsImg from "../../../../assets/images/mentor_profile/hands.png";
import highlightImg from "../../../../assets/images/mentor_profile/highlight.png";
import starImg from "../../../../assets/images/mentor_profile/star.png";
import { useUploadVideo } from "../../hooks/useUploadVideo";
import { MentorProfileDetails } from "./AcademicBackground";
import { EditDemoVideoModal } from "../EditDemoVideoModal/EditDemoVideoModal";
import { EditDetailsButton } from "../EditDetailsButton/EditDetailsButton";
import { DESKTOP_BREAKPOINT } from "../../consts";

export const AboutMe = ({
  profileData = {},
  setProfileData,
  isPublicProfile = false,
  isProfilePage = false,
  onOpenEdit,
}) => {
  const classes = useAboutMeStyles();
  // -0.05 matches MUI v4's own theme.breakpoints.down() step, so this is the exact same
  // (max-width) query the old useTheme()-based version produced — not just "close enough".
  const isMobile = useMediaQuery(`(max-width:${DESKTOP_BREAKPOINT - 0.05}px)`);
  const hiddenFileInput = useRef(null);
  const [isDemoVideoModalOpen, setIsDemoVideoModalOpen] = useState(false);

  const {
    about = "",
    degree = "",
    college = "",
    highExpertiseIn = [],
    contact_no = "",
    email = "",
    videoUrl = "",
    mockDemoVideoUrl = "",
  } = profileData;

  const canEdit = !!setProfileData;

  const { selectAndUpload, uploadVideoLoading } = useUploadVideo(
    setProfileData || (() => { }),
  );

  return (
    <div className={classes.outerWrapper}>
      {canEdit && (
        <input
          ref={hiddenFileInput}
          type="file"
          accept=".mp4"
          className={classes.hiddenInput}
          onChange={selectAndUpload}
        />
      )}
      {isPublicProfile && (
        <img src={handsImg} alt="" className={classes.handsImage} />
      )}
      <section
        className={
          isPublicProfile ? classes.wrapper : classes.wrapperWithoutPadding
        }
      >
        <div className={classes.titleWrapper}>
          <div className={classes.title}>
            Get to know{" "}
            <span className={classes.titleME}>
              ME
              <img src={highlightImg} alt="" className={classes.highlightImg} />
            </span>
          </div>
          {!isProfilePage && !isMobile && onOpenEdit && (
            <EditDetailsButton onEditProfile={onOpenEdit} />
          )}
        </div>

        <div className={classes.description}>
          {about || "About me description not available."}
        </div>

        {highExpertiseIn && highExpertiseIn.length > 0 && (
          <div className={classes.expertiseSection}>
            <div className={classes.sectionLabel}>High expertise in:</div>
            <div className={classes.expertiseChips}>
              {highExpertiseIn.map((item) => (
                <span key={item} className={classes.expertiseChip}>
                  <img src={starImg} alt="" />
                  <span className={classes.academicText}>{item}</span>
                </span>
              ))}
            </div>
          </div>
        )}

        <MentorProfileDetails
          degree={degree}
          college={college}
          isPublicProfile={isPublicProfile}
          contact_no={contact_no}
          email={email}
          videoUrl={videoUrl}
          mockDemoVideoUrl={mockDemoVideoUrl}
          canEdit={canEdit}
          onReplaceVideo={() => hiddenFileInput.current.click()}
          onReplaceDemoVideo={() => setIsDemoVideoModalOpen(true)}
        />
      </section>

      <EditDemoVideoModal
        isOpen={isDemoVideoModalOpen}
        onClose={() => setIsDemoVideoModalOpen(false)}
        currentUrl={mockDemoVideoUrl}
        onSaveSuccess={(newUrl) =>
          setProfileData && setProfileData((prev) => ({ ...prev, mockDemoVideoUrl: newUrl }))
        }
      />
    </div>
  );
};
